import { useState, useEffect, useCallback } from 'react';
import { useDispatch, useSelector } from 'react-redux';

import ScrollView from '../../molecules/scrollView';
import Title from '../../atoms/title';

import { INIT_REQUEST_UPBIT } from '../../../store/modules/upbit';
import { SELECT_COIN } from '../../../store/modules/coin';

import { upbit } from '../../../apis/coin';

export interface Coin {
  name: string
  open: number
  close: number
  volume: number
}


export interface Props {
  title: boolean

}

const Upbit = (props: Props) => {
  const dispatch = useDispatch();
  const [coins, setCoins] = useState([])
  const { data = [] } = useSelector((state: any) => ({
    data: state.upbit.data
  }))

  useEffect(() => {
    (async () => {
      let data = await upbit()
      setCoins(data)
    })()
  }, [])

  useEffect(() => {
    dispatch({
      type: INIT_REQUEST_UPBIT,
      payload: coins
    })
  }, [coins])

  const onClickHandler = useCallback((c: string) => {
    dispatch({
      type: SELECT_COIN,
      payload: {
        select: c
      }
    })
  }, [])

  return (
    <>
      {props.title && <Title value="업비트" upbit/>}
      <ScrollView
        data={data}
        heads={['한글명', '현재가', '전일대비', '거래량']}
        onRowClick={onClickHandler}
        vholc
      />
    </>
  );
};

export default Upbit;
